export default {
  ca: 'catalan',
  de: 'deutsch',
  en: 'english',
  'en-gb': 'english (GB)',
  es: 'español',
  eu: 'euskara',
  fr: 'français',
  it: 'italiano',
  nb: 'norsk',
};
